<template>
  <v-card :loading="false" title="AI" class="text-left pa-4">
    <v-card-text>
      Enter a prompt for what you want the AI to look for in the database.
    </v-card-text>
    <v-card-text>
      <v-row class="d-flex align-center">
        <v-col cols="8">
          <v-text-field
            v-model="iterations"
            type="number"
            variant="outlined"
            density="compact"
            rounded="0"
            label="Number of Iterations"
            placeholder="Enter number of iterations..."
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="d-flex align-center">
        <v-col cols="8">
          <v-text-field
            v-model="prompt"
            variant="outlined"
            density="compact"
            rounded="0"
            label="Prompt"
            placeholder="Enter prompt here..."
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="d-flex align-center">
        <v-col cols="3" class="d-flex mb-5">
          <v-btn @click="submitPrompt" color="primary" :disabled="loading">
            <template v-if="loading">
              <v-progress-circular
                indeterminate
                color="white"
                size="20"
              ></v-progress-circular>
            </template>
            <template v-else> Submit </template>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text>
      <v-list>
        <v-list-item
          v-for="(message, index) in response"
          :key="index"
          class="py-1"
        >
          <v-list-item-content>
            <v-list-item-title style="white-space: normal">{{
              message
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "NAME",
  data: () => ({
    prompt: "",
    response: "",
    loading: false,
    iterations: 2,
  }),
  components: {},
  computed: {},
  props: {},
  mounted() {},
  methods: {
    submitPrompt() {
      this.loading = true;
      this.$axios
        .post("/ai-main", { prompt: this.prompt, iterations: this.iterations })
        .then(
          function (response) {
            // handle success
            this.saving = false;
            this.emit.emit("systemMessage", {
              title: "Successfully processed",
              message: response.data.message,
              timeout: 3000,
              colour: "success",
            });
            this.response = response.data.history;
          }.bind(this),
        )
        .catch(
          function (error) {
            console.log(error.message);
            this.emit.emit("systemMessage", {
              title: "Error!",
              message: error.response?.data?.message || error.message,
              timeout: 3000,
              colour: "error",
            });
          }.bind(this),
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {},
};
</script>

<style scoped></style>
